declare namespace $ {

	type $mol_button_minor__attr_bog_theme_switch_1 = $mol_type_enforce<
		({ 
			'bog_theme_switch_active': ReturnType< $bog_theme_switch['light_active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__hint_bog_theme_switch_2 = $mol_type_enforce<
		ReturnType< $bog_theme_switch['light_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_theme_switch_3 = $mol_type_enforce<
		ReturnType< $bog_theme_switch['set_light'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_theme_switch_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_bog_theme_switch_5 = $mol_type_enforce<
		({ 
			'bog_theme_switch_active': ReturnType< $bog_theme_switch['system_active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__hint_bog_theme_switch_6 = $mol_type_enforce<
		ReturnType< $bog_theme_switch['system_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_theme_switch_7 = $mol_type_enforce<
		ReturnType< $bog_theme_switch['set_system'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_theme_switch_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_bog_theme_switch_9 = $mol_type_enforce<
		({ 
			'bog_theme_switch_active': ReturnType< $bog_theme_switch['dark_active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__hint_bog_theme_switch_10 = $mol_type_enforce<
		ReturnType< $bog_theme_switch['dark_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_theme_switch_11 = $mol_type_enforce<
		ReturnType< $bog_theme_switch['set_dark'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_theme_switch_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_theme_switch extends $mol_view {
		light_active( ): boolean
		light_hint( ): string
		set_light( next?: any ): any
		Light_icon( ): $mol_icon_white_balance_sunny
		Light( ): $mol_button_minor
		system_active( ): boolean
		system_hint( ): string
		set_system( next?: any ): any
		System_icon( ): $mol_icon_monitor
		System( ): $mol_button_minor
		dark_active( ): boolean
		dark_hint( ): string
		set_dark( next?: any ): any
		Dark_icon( ): $mol_icon_weather_night
		Dark( ): $mol_button_minor
		theme_auto( ): $bog_theme_auto
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map